// extracted by mini-css-extract-plugin
export default {"numberTag":"NumberTag_numberTag__uE4AW","sizeDefault":"NumberTag_sizeDefault__R30Sg","sizeSmall":"NumberTag_sizeSmall__8I5YI","sizeLarge":"NumberTag_sizeLarge__4SGyN"};